<template>
    <div
        class="option-choice"
        role="group">
        <div class="input-group option-text-group">
            <label for="option-input-title">{{ $t('rating.option_title') }}</label>
            <div class="input-group-prepend">
                <div
                    class="input-group-text btnGroupAddon"
                    :class="error.title && 'bg-danger'">
                    <i
                        class="far fa-text"
                        v-if="!error.title"></i>
                    <i
                        class="fal fa-exclamation-circle"
                        v-else></i>
                </div>
            </div>
            <b-form-input
                id="option-input-title"
                v-model="option.title"
                @change="updateOptionTitle"></b-form-input>
        </div>

        <div
            class="input-group option-value-group"
            v-if="parseInt(section.type) === 1">
            <label for="option-input-value">{{ $t('rating.maximum_option_points') }}</label>
            <div class="input-group-prepend">
                <div
                    class="input-group-text btnGroupAddon"
                    :class="error.max && 'bg-danger'">
                    <i
                        class="fab fa-maxcdn"
                        v-if="!error.max"></i>
                    <i
                        class="fal fa-exclamation-circle"
                        v-else></i>
                </div>
            </div>
            <b-form-input
                id="option-input-value"
                v-model="option.max"
                @change="updateOptionMax"></b-form-input>
        </div>

        <b-button
            class="btn-remove btn-remove-option desktop d-none d-lg-flex"
            v-b-tooltip.hover
            :title="$t('common.delete')"
            variant="danger-icon"
            @click="deleteOption">
        </b-button>

        <b-button
            class="btn-remove-option mobile d-flex d-lg-none"
            variant="danger-icon"
            @click="deleteOption">
            <i class="btn-remove-fad"></i>{{ $t('common.delete') }}
        </b-button>
    </div>
</template>

<script>
import draggable from 'vuedraggable';

export default {
    name: 'design-2021-rating-edit-option-component',
    props: ['option', 'section'],
    components: {
        draggable,
    },
    data() {
        return {
            error: {
                title: false,
                titleMessage: this.$t('rating.title_cannot_be_empty'),
                max: false,
                maxMessage: this.$t('rating.maximum_value_cannot_be_empty_it_must_be_an_integer'),
            },
        };
    },

    methods: {
        updateOptionTitle(value) {
            this.error.title = false;
            this.$emit('clear-error', 'title');

            if (value === '') {
                this.error.title = true;
                this.$emit('trigger-error', 'title');
                return;
            }

            const data = {
                title: value,
                id: this.option.id,
            };

            this.axios.post(this.routes.ratingOptionTitle(), data).then(
                (response) => {
                    this.option.update({ title: value });
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        updateOptionMax(value) {
            this.error.max = false;
            this.$emit('clear-error', 'max');

            if (value === '' || isNaN(parseInt(value))) {
                this.error.max = true;
                this.$emit('trigger-error', 'max');
                return;
            }

            const data = {
                max: parseInt(value),
                id: this.option.id,
            };

            this.axios.post(this.routes.ratingOptionMax(), data).then(
                (response) => {
                    this.option.update({ max: parseInt(value) });
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },

        deleteOption() {
            this.alert.saving();

            this.axios.delete(this.routes.ratingOptionDelete(this.option.id)).then(
                (response) => {
                    this.option.remove();
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
};
</script>

<style scoped lang="scss">
.errors {
    display: flex;
    flex: 1 0 100%;
}

.option-choice {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
    column-gap: map-get($grid-gutter-spacing, 'fifteen');
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');

    .input-group {
        margin-bottom: map-get($grid-gutter-spacing, 'fifteen');

        label {
            flex: 1 0 100%;
        }

        .input-group-text {
            border-top-left-radius: $border-radius-content;
            border-bottom-left-radius: $border-radius-content;
        }
    }

    .btn-remove-option {
        font-size: $base-font-size;

        i {
            font-style: normal;
            align-self: center;
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'lg')) {
    .option-choice {
        .input-group {
            width: calc(50% - 33px);
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'xl')) {
    .option-choice {
        .input-group {
            margin-bottom: 0;
        }
    }
}
</style>
